exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manual-link{cursor:pointer;display:block;text-decoration:underline}", ""]);

// exports
